import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/context/AuthContext";
import { getMcpCatalog } from "@/services/api/in-app-agent";

export function useMcpCatalog(enabled: boolean) {
  const { user } = useAuth();
  const companyId = user?.company_id;

  return useQuery({
    queryKey: ["in-app-agent-mcp-catalog", companyId],
    queryFn: () => getMcpCatalog(),
    enabled: enabled && Boolean(companyId),
    staleTime: 60_000,
  });
}
